"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TravelDatesActionTypes = void 0;
var TravelDatesActionTypes;
(function (TravelDatesActionTypes) {
    TravelDatesActionTypes["SET_DURATION"] = "SET_DURATION";
    TravelDatesActionTypes["RESET_DATES"] = "RESET_DATES";
    TravelDatesActionTypes["SET_DEPARTURE_DATE"] = "SET_DEPARTURE_DATE";
    TravelDatesActionTypes["SET_RETURN_DATE"] = "SET_RETURN_DATE";
    TravelDatesActionTypes["SET_SEARCH_TYPE"] = "SET_SEARCH_TYPE";
    TravelDatesActionTypes["CLEAR_DATE_RANGE"] = "CLEAR_DATE_RANGE";
})(TravelDatesActionTypes || (exports.TravelDatesActionTypes = TravelDatesActionTypes = {}));
//# sourceMappingURL=TravelDates.types.js.map